<template>
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_11110_5587)">
      <path d="M21.9044 14.4999C22.1806 14.4999 22.4044 14.2761 22.4044 13.9999C22.4044 13.7238 22.1806 13.4999 21.9044 13.4999H19.2068L23.0199 9.68681C23.2152 9.49154 23.2152 9.17496 23.0199 8.9797C22.8246 8.78444 22.508 8.78444 22.3128 8.9797L18.4997 12.7928V10.0952C18.4997 9.81901 18.2758 9.59516 17.9997 9.59516C17.7235 9.59516 17.4997 9.81901 17.4997 10.0952V13.9999C17.4997 14.2761 17.7235 14.4999 17.9997 14.4999H21.9044Z"/>
      <path d="M10.0949 17.4999C9.81877 17.4999 9.59491 17.7238 9.59491 17.9999C9.59491 18.2761 9.81877 18.4999 10.0949 18.4999H12.7926L8.97945 22.313C8.78419 22.5083 8.78419 22.8249 8.97945 23.0201C9.17472 23.2154 9.4913 23.2154 9.68656 23.0201L13.4997 19.207V21.9047C13.4997 22.1808 13.7235 22.4047 13.9997 22.4047C14.2758 22.4047 14.4997 22.1808 14.4997 21.9047V17.9999C14.4997 17.7238 14.2758 17.4999 13.9997 17.4999H10.0949Z"/>
    </g>
    <defs>
      <clipPath id="clip0_11110_5587">
        <rect width="16" height="16" fill="white" transform="translate(8 8)"/>
      </clipPath>
    </defs>
  </svg>
</template>
